import React, { MouseEventHandler } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import Divider from '@material-ui/core/Divider';

import { translate } from 'containers/services/translate';
import messages from 'components/SahamDrawer/messages';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import {
  DrawerContainer,
  DrawerDiv,
} from 'components/SahamDrawer/styled-components';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import { IconButton, InputAdornment, TextField } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
export interface SahamDrawerProps {
  intl: IntlShape;
  handleToggleDrawer: any;
  open: boolean;
  children?: React.ReactNode;
  title: string;
  isValidation?: boolean;
  handleValidateDrawer?: MouseEventHandler<any>;
  isSaveButtonDisabled?: boolean;
  isDisplayCloseButton?: boolean;
  confirmButtonTitle?: string;
  rejectButtonTitle?: string;
  isRejectButtonDisabled?: boolean;
  isDisplayCancelButton?: boolean;
  handleRejectDrawer?: MouseEventHandler<any>;
  handleScroll?: any;
  isInstruction?: any;
  handleChange?: any;
  value?: string;
  primaryButtonTitle?: string;
  isPrimaryButtonDisabled?: boolean;
  handleClickPrimaryButton?: MouseEventHandler<any>;
  disableReason?: any;
}

const SahamDrawer: React.FC<SahamDrawerProps> = (props): JSX.Element => {
  const shouldShowReasons =
    props.isRejectButtonDisabled &&
    props.isSaveButtonDisabled &&
    Array.isArray(props.disableReason) &&
    props.disableReason.length > 0;

  return (
    <DrawerContainer
      anchor="right"
      open={props.open}
      onClose={props.handleToggleDrawer}
    >
      <DrawerDiv>
        <div className="titleConatainer">
          <span className="title">{props.title}</span>
          {props.isDisplayCloseButton && (
            <ClearOutlinedIcon
              data-testid={'close-icon'}
              onClick={props.handleToggleDrawer}
            />
          )}
        </div>
        <Divider className="divider" />
        <div
          className="content"
          onScroll={props.handleScroll && props.handleScroll}
        >
          {props.children}
        </div>
        <div className="actions">
          {shouldShowReasons && (
            <div className="disabled-message">
              <span
                style={{
                  color: COLORS.GREY,
                  fontStyle: 'italic',
                  fontWeight: 'bold',
                }}
              >
                {translate({ ...messages.disableReasonsTitle }, props)}
              </span>
              {props.disableReason && Array.isArray(props.disableReason) && (
                <ul style={{ color: COLORS.GREY, fontStyle: 'italic' }}>
                  {props.disableReason.map((reason, index) => (
                    <li key={index}>{reason}</li>
                  ))}
                </ul>
              )}
            </div>
          )}
          <Divider className="divider" />
          <div className="action-buttons-container">
            {props.isDisplayCancelButton && (
              <SecondaryButton
                className="cancelButton"
                onClick={props.handleToggleDrawer}
                title={translate({ ...messages.cancel }, props)}
              />
            )}
            {props.confirmButtonTitle && (
              <PrimaryButton
                data-testid="validate-drawer"
                variant="contained"
                className={
                  props.isSaveButtonDisabled
                    ? 'disabledSaveButton'
                    : 'saveButton'
                }
                onClick={props.handleValidateDrawer}
                title={props.confirmButtonTitle}
                disabled={props.isSaveButtonDisabled}
              />
            )}
            {props.rejectButtonTitle && (
              <PrimaryButton
                data-testid="reject-drawer"
                variant="contained"
                className={
                  props.isRejectButtonDisabled
                    ? 'disabledRejectButton'
                    : 'rejectButton'
                }
                onClick={props.handleRejectDrawer}
                title={props.rejectButtonTitle}
                disabled={props.isRejectButtonDisabled}
                background={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                border={BUTTON_COLORS.RED_BUTTON_TITLE}
                titlecolor={BUTTON_COLORS.RED_BUTTON_TITLE}
              />
            )}
            {props.primaryButtonTitle && (
              <PrimaryButton
                data-testid="primary-button"
                variant="contained"
                className={
                  props.isPrimaryButtonDisabled
                    ? 'disabledSaveButton'
                    : 'saveButton'
                }
                onClick={props.handleClickPrimaryButton}
                title={props.primaryButtonTitle}
                disabled={props.isPrimaryButtonDisabled}
                background={BUTTON_COLORS.PRIMARY_BLUE}
                border={BUTTON_COLORS.PRIMARY_BLUE}
                titlecolor={COLORS.WHITE}
              />
            )}
            {props.isInstruction && (
              <TextField
                name="text"
                variant="outlined"
                placeholder="Message"
                onChange={props.handleChange}
                value={props.value}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        color="primary"
                        onClick={props.handleValidateDrawer}
                        data-testid="send"
                      >
                        <SendIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  style: { borderRadius: '25px' },
                }}
              />
            )}
          </div>
        </div>
      </DrawerDiv>
    </DrawerContainer>
  );
};

SahamDrawer.defaultProps = { isDisplayCancelButton: true };

export default injectIntl(SahamDrawer);
